module.exports = __webpack_public_path__ + "assets/img/default-app-icon.ccb46589.png";